<template>
    <div>
        <FormRowTwo :fieldNameArr="[$t('TOOLING_TYPE') + ': ']" :fieldWidthArr="[364]" :fieldSpanWidthArr="[102]">
            <Input class="Input" v-model="tooling.toolingType" slot="a" disabled />
        </FormRowTwo>
        <FormRowTwo v-if="toolingQuotationType == 'MODIFY'" :fieldNameArr="[$t('MODIFY_DESCRIPTION')]">
            <Input style="width: 1200px" v-model="tooling.modifyDescription" slot="a" type="textarea" disabled />
        </FormRowTwo>
        <FormRowTwo v-if="toolingQuotationType == 'NEW'"
            :fieldNameArr="[$t('LEAD_TIME'), $t('CAVITY'), $t('TOOLING_LIFETIME'), $t('CYCLE_TIME')]"
            :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">
            <Input class="Input" v-model="tooling.attribute.leadTime" slot="a" disabled>
                <span slot="append">{{ $t('DAYS') }}</span>
            </Input>
            <Input class="Input" v-model="tooling.attribute.cavity" slot="b" disabled />
            <Input class="Input" v-model="tooling.attribute.lifeTime" slot="c" disabled />
            <Input class="Input" v-model="tooling.attribute.cycleTime" slot="d" disabled />
        </FormRowTwo>
        <Card v-if="toolingQuotationType == 'NEW'" :title="$t('BASIC')" class="card-warning mt-3">
            <FormRowTwo
                :fieldNameArr="[$t('LENGTH') + ': ', $t('MACHINE_TONNAGE') + ': ', $t('TOTAL_WEIGHT') + ': ', $t('WIDTH') + ': ']"
                :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">
                <Input class="Input" v-model="tooling.attribute.length" slot="a" disabled />
                <Input class="Input" v-model="tooling.attribute.machineTonnage" slot="b" disabled />
                <Input class="Input" v-model="tooling.attribute.totalWeight" slot="c" disabled />
                <Input class="Input" v-model="tooling.attribute.width" slot="d" disabled />
            </FormRowTwo>
            <FormRowTwo
                :fieldNameArr="[$t('BASE_MATERIAL') + ': ', $t('OTHER_ACCESSORIES') + ': ', $t('HEIGHT') + ': ', $t('MANAGEMENT_PROFIT') + ': ']"
                :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">
                <Input class="Input" v-model="tooling.attribute.baseMaterial" :maxlength="255" slot="a" disabled />
                <Input class="Input" v-model="tooling.attribute.otherAccessories" :maxlength="255" slot="b" disabled />
                <Input class="Input" v-model="tooling.attribute.height" slot="c" disabled />
                <Input class="Input" v-model="tooling.attribute.managementProfit" slot="d" disabled />
            </FormRowTwo>
        </Card>
        <Card v-if="toolingQuotationType == 'NEW'" :title="$t('PRICE')" class="card-warning mt-3">
            <FormRowTwo
                :fieldNameArr="[$t('DESIGN_AND_TESTING_PRICE') + ': ', $t('OTHER_ACCESSORIES_TOTAL_PRICE') + ': ', $t('FORMWORK_PRICE') + ': ']"
                :fieldWidthArr="[444, 444, 444]" :fieldSpanWidthArr="[182, 182, 182]">
                <Input class="Input" v-model="tooling.attribute.designAndTestingPrice" slot="a" disabled />
                <Input class="Input" v-model="tooling.attribute.otherAccessoryTotalPrice" slot="b" disabled />
                <Input class="Input" v-model="tooling.attribute.formworkPrice" slot="c" disabled />
            </FormRowTwo>
        </Card>
        <Card v-if="toolingQuotationType == 'NEW'" :title="$t('SPECIAL')" class="card-warning mt-3">
            <FormRowTwo :fieldNameArr="[isPLASTIC + $t('COLD_HOT_RUNNER') + ': ', isSTAMPINGOrCONNECTOR + $t('NUMBER_OF_STEP') + ': ',
            isDIECASTING + $t('NUMBER_OF_SLIDER') + ': ', isPACKING + $t('DRY_WET_PRESSURE') + ': ']"
                :fieldWidthArr="[414, 414, 414, 414]" :fieldSpanWidthArr="[152, 152, 152, 152]">
                <Input class="Input" v-model="tooling.attribute.coldHotRunner" :maxlength="255" slot="a" disabled />
                <Input class="Input" v-model="tooling.attribute.numberOfStep" slot="b" disabled />
                <Input class="Input" v-model="tooling.attribute.numberOfSlider" slot="c" disabled />
                <Input class="Input" v-model="tooling.attribute.dryWetProcess" slot="d" disabled />
            </FormRowTwo>
        </Card>
        <Card v-if="toolingQuotationType == 'MODIFY'" :title="$t('OTHER')" class="card-secondary mt-3">
            <FormRowTwo :fieldNameArr="[$t('OTHER_ACCESSORIES') + ': ', $t('OTHER_ACCESSORIES_TOTAL_PRICE') + ': ']"
                :fieldWidthArr="[414, 414]" :fieldSpanWidthArr="[152, 152]">
                <Input class="Input" v-model="tooling.attribute.otherAccessory" :maxlength="255" slot="a" disabled />
                <Input class="Input" v-model="tooling.attribute.otherAccessoryTotalPrice" slot="b" disabled />
            </FormRowTwo>
        </Card>
        <Card :title="$t('MATERIAL')" class="card-warning mt-3">
            <Table border :columns="materialColumn" :data="tooling.materials"></Table>
        </Card>
        <Card
            v-if="(toolingQuotationType == 'NEW' || toolingQuotationType == 'MODIFY') && tooling.attribute.molds && tooling.attribute.molds.length > 0"
            :title="$t('MOLDS')" class="card-secondary mt-3">
            <Table border :columns="moldColumn" :data="tooling.attribute.molds">
            </Table>
        </Card>
        <Card
            v-if="(toolingQuotationType == 'NEW' || toolingQuotationType == 'MODIFY') && tooling.attribute.molds && tooling.attribute.molds.engineerings > 0"
            :title="$t('ENGINEERING')" class="card-secondary mt-3">
            <Table border :columns="engineeringColumn" :data="tooling.attribute.engineerings">
            </Table>
        </Card>
    </div>
</template>
   
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { ToolingMaterial } from "@/util/tableTitle"
import FormRowTwo from '@/components/FormRowTwo'
import ToolingAttributes from "@/views/quotation/ToolingAttributes"

export default {
    name: "ToolingrCompoment",
    components: {
        FormRowTwo,
        ToolingAttributes
    },
    props: {
        tooling: {
            type: Object,
            default: () => null,
        },
        toolingQuotationType: {
            type: String,
            default: () => "",
        }
    },
    data() {
        return {
            materialColumn: ToolingMaterial(this),
            moldColumn: [
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('MOLD_MATERIAL');
                        return h('div', {
                            domProps: {
                                innerHTML: text
                            }
                        })
                    },
                    align: 'center',
                    key: 'material'
                },
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('MOLD_RAW_MATERIAL_PRICE');
                        return h('div', {
                            domProps: {
                                innerHTML: text
                            }
                        })
                    },
                    align: 'center',
                    key: 'rawMaterialPrice'
                },
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('MOLD_PROCESSING_FEE');
                        return h('div', {
                            domProps: {
                                innerHTML: text
                            }
                        })
                    },
                    align: 'center',
                    key: 'processingFee'
                }
            ],
            engineeringColumn: [
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('ENGINEERING_TL_QUANTITY');
                        return h('div', {
                            domProps: {
                                innerHTML: text
                            }
                        })
                    },
                    align: 'center',
                    key: 'quantity'
                },
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('ENGINEERING_WEIGHT');
                        return h('div', {
                            domProps: {
                                innerHTML: text
                            }
                        })
                    },
                    align: 'center',
                    key: 'weight'
                }
            ],
        }
    },
    methods: {
        ...mapGetters(["getModalSize"]),
        ...mapActions(["toggleLoading"]),

    },
    computed: {

    },
}
</script>
 
<style scoped></style>
   